import React from "react";
const Q2 = () => {
  return (
    <div style={{ backgroundColor: "#Dbe6ea" }}>
      <div className="ans-bank">
        <div className="qta">What are terms & conditions?</div>
        <p>
          In its sole discretion, the Sponsor reserves the right to modify,
          suspend, cancel, or terminate the T-Shirt Giveaway should
          non-authorized human intervention, a bug or virus,fraud, or other
          causes beyond the Sponsor’s control, impact or corrupt the security,
          fairness, proper conduct, or administration of the T-Shirt Giveaway.
          The Sponsor, in the event of any of the above issues, may determine
          the Winner based on all eligible entries received prior to and/or
          after (if appropriate) the action taken by the Sponsor. Individuals
          who tamper with or attempt to tamper with the operation or entry
          process of the Giveaway or website or violates these Terms &
          Conditions will be disqualified by the Sponsor in its sole discretion.
          In its sole discretion, the Sponsor has the right to maintain the
          integrity of the T-Shirt Giveaway, to void votes for any reason,
          including, but not limited to: [identify any disallowed entry methods
          that will result in votes/entries being voided; examples: multiple
          entries from the same user; multiple entries from the same computer
          beyond the number allowed by the Giveaway rules; or the use of bots,
          macros, scripts, or other technical means for entering.] Attempts by
          any entrant to deliberately damage any website or undermine the
          legitimate operation of the T-Shirt Giveaway may be aviolation of
          criminal and civil laws. If any such attempt is made,the Sponsor
          reserves the right to seek damages to the fullest extent permitted by
          law
        </p>
      </div>
    </div>
  );
};

export default Q2;
